import palette from 'constants/palette'
import React from 'react'

type Props = {
  size?: number
  color?: string
}

// Decorative section/card glyphs for the Universal Promo Codes overview. They
// always sit next to a visible label, so every one is aria-hidden.
const svgProps = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 16 16',
  fill: 'none' as const,
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
})

export const TagIcon = ({ size = 16, color = palette.spearmint50 }: Props) => (
  <svg {...svgProps(size)}>
    <path
      d="M1.5 1.5h6.1c.27 0 .52.1.71.29l6.1 6.1a1 1 0 0 1 0 1.41l-5.1 5.1a1 1 0 0 1-1.41 0l-6.1-6.1a1 1 0 0 1-.3-.71V1.5Z"
      stroke={color}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <circle cx="4.9" cy="4.9" r="1.1" fill={color} />
  </svg>
)

export const StarIcon = ({ size = 16, color = palette.belizeHole }: Props) => (
  <svg {...svgProps(size)}>
    <path
      d="M8 1.6l1.94 3.93 4.34.63-3.14 3.06.74 4.32L8 11.5l-3.88 2.04.74-4.32L1.72 6.16l4.34-.63L8 1.6Z"
      stroke={color}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
)

export const MobileOrderingIcon = ({
  size = 16,
  color = palette.grey70,
}: Props) => (
  <svg {...svgProps(size)}>
    <rect
      x="4.2"
      y="1.2"
      width="7.6"
      height="13.6"
      rx="1.6"
      stroke={color}
      strokeWidth="1.4"
    />
    <path
      d="M6.9 12.6h2.2"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
)

export const StorefrontIcon = ({
  size = 16,
  color = palette.grey70,
}: Props) => (
  <svg {...svgProps(size)}>
    <path
      d="M2 6.2 3.1 2.6h9.8L14 6.2M2 6.2h12M2 6.2v7.2h12V6.2"
      stroke={color}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M6.3 13.4V9.3h3.4v4.1"
      stroke={color}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
)

export const ClockIcon = ({ size = 16, color = palette.eggYolk }: Props) => (
  <svg {...svgProps(size)}>
    <circle cx="8" cy="8" r="6.3" stroke={color} strokeWidth="1.4" />
    <path
      d="M8 4.6V8l2.3 1.7"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ExclamationCircleIcon = ({
  size = 16,
  color = palette.eggYolk,
}: Props) => (
  <svg {...svgProps(size)}>
    <circle cx="8" cy="8" r="6.3" stroke={color} strokeWidth="1.4" />
    <path d="M8 4.6v4" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <circle cx="8" cy="11.1" r="0.85" fill={color} />
  </svg>
)

export const CheckIcon = ({
  size = 14,
  color = palette.spearmint50,
}: Props) => (
  <svg {...svgProps(size)}>
    <path
      d="M2.6 8.4 6.2 12l7.2-8"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
